module.exports = __webpack_public_path__ + "img/icon_map_61_off_011.0074ada1.png";